export default class CountDownTimer {
  constructor(duration, granularity) {
    this.duration = duration;
    this.granularity = granularity || 1000;
    this.tickFtns = [];
    this.expireFtns = [];
    this.running = false;
  }

  parse = (seconds) => {
    return {
      minutes: (seconds / 60) | 0,
      seconds: seconds % 60 | 0,
    };
  };

  start = () => {
    if (this.running) {
      return;
    }
    this.running = true;
    let start = Date.now(),
      that = this,
      diff,
      obj;

    const timer = () => {
      diff = that.duration - (((Date.now() - start) / 1000) | 0);

      if (diff > 0) {
        this.timeout = setTimeout(timer, that.granularity);
      } else {
        diff = 0;
        that.running = false;

        that.expireFtns.forEach((ftn) => {
          ftn.call(this);
        }, that);
      }

      obj = this.parse(diff);
      that.tickFtns.forEach((ftn) => {
        ftn.call(this, obj.minutes, obj.seconds);
      }, that);
    };
    timer();
  };

  onTick = (ftn) => {
    if (typeof ftn === 'function') {
      this.tickFtns.push(ftn);
    }
    return this;
  };

  onExpire = (ftn) => {
    if (typeof ftn === 'function') {
      this.expireFtns.push(ftn);
    }
    return this;
  };

  expired = () => {
    return !this.running;
  };

  destroy = () => {
    this.expireFtns = [];
    this.tickFtns = [];
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  };
}
